/**
 * Mouse drag-to-scroll for the cart drawer "You may also like" row.
 * Delegated on document, so it keeps working after the drawer HTML is re-rendered.
 * Touch/pen are ignored here (native swipe already works).
 */
(function () {
  if (window.__mbCartRecDrag) return;
  window.__mbCartRecDrag = true;

  var TRACK = ".f-cart-recommendations__track";
  var ITEM = ".f-cart-recommendations__item";
  var THRESHOLD = 5;   // px before a press becomes a drag (keeps +ADD clicks working)
  var MOMENTUM = 180;  // how far a flick carries

  var track = null, isDown = false, moved = false, pointerId = null;
  var startX = 0, startScroll = 0, targetScroll = 0, rafId = null, samples = [];

  function maxScroll(el) { return el.scrollWidth - el.clientWidth; }

  function render() {
    if (track) track.scrollLeft = targetScroll;
    rafId = null;
  }

  function nearestItemLeft(el, projected) {
    var elLeft = el.getBoundingClientRect().left;
    var best = projected, bestDist = Infinity;
    el.querySelectorAll(ITEM).forEach(function (item) {
      var left = item.getBoundingClientRect().left - elLeft + el.scrollLeft;
      var dist = Math.abs(left - projected);
      if (dist < bestDist) { bestDist = dist; best = left; }
    });
    return Math.max(0, Math.min(best, maxScroll(el)));
  }

  function cancelSettle(el) {
    if (el && el.__mbSettle) {
      el.__mbSettle();          // clears the pending timer + listener
      el.__mbSettle = null;
    }
  }

  function settle(el) {
    cancelSettle(el);
    var timer;
    var done = function () {
      clearTimeout(timer);
      el.removeEventListener("scrollend", done);
      el.classList.remove("is-dragging");
      el.__mbSettle = null;
    };
    el.addEventListener("scrollend", done);
    timer = setTimeout(done, 700); // fallback for browsers without scrollend
    el.__mbSettle = function () {
      clearTimeout(timer);
      el.removeEventListener("scrollend", done);
    };
  }

  document.addEventListener("pointerdown", function (e) {
    if (e.pointerType !== "mouse" || e.button !== 0) return;
        var el = e.target.closest(TRACK);
    if (!el || el.scrollWidth <= el.clientWidth) return;
    cancelSettle(el);                  // stop the previous glide's timer
    el.classList.remove("is-dragging");
    track = el;
    isDown = true;
    moved = false;
    pointerId = e.pointerId;
    startX = e.clientX;
    startScroll = el.scrollLeft;
    targetScroll = startScroll;
    samples = [{ x: e.clientX, t: performance.now() }];
  });

  document.addEventListener("pointermove", function (e) {
    if (!isDown || !track || e.pointerId !== pointerId) return;
    if (e.buttons !== 1) { endDrag(); return; }
    var dx = e.clientX - startX;
    if (!moved) {
      if (Math.abs(dx) < THRESHOLD) return;
      moved = true;
      track.classList.add("is-dragging");
    }
    e.preventDefault();
    samples.push({ x: e.clientX, t: performance.now() });
    if (samples.length > 10) samples.shift();
    targetScroll = Math.max(0, Math.min(startScroll - dx, maxScroll(track)));
    if (!rafId) rafId = requestAnimationFrame(render); // one scroll write per frame
  });

  function endDrag() {
    if (!isDown || !track) return;
    isDown = false;
    var el = track;
    if (!moved) { track = null; return; }

    if (rafId) { cancelAnimationFrame(rafId); render(); }

    var velocity = 0, now = performance.now();
    var recent = samples.filter(function (s) { return now - s.t < 100; });
    if (recent.length > 1) {
      var first = recent[0], last = recent[recent.length - 1];
      velocity = (last.x - first.x) / ((last.t - first.t) || 1);
    }

    var target = nearestItemLeft(el, el.scrollLeft - velocity * MOMENTUM);
    settle(el);
    el.scrollTo({ left: target, behavior: "smooth" });
    track = null;
  }

  document.addEventListener("pointerup", endDrag);
  document.addEventListener("pointercancel", endDrag);

  // Block the click that fires right after a drag (so links / +ADD don't trigger)
  document.addEventListener("click", function (e) {
    if (moved && e.target.closest(TRACK)) {
      e.preventDefault();
      e.stopPropagation();
    }
    moved = false;
  }, true);

  // Stop native image/link ghost-drag inside the row
  document.addEventListener("dragstart", function (e) {
    if (e.target.closest && e.target.closest(TRACK)) e.preventDefault();
  });
})();